// un-authenticated
import publicPages from "./public/index.js";
// authenticated
import complianceReport from "./compliance/compliance.js";
import dashboard from "./dashboard/index.js";
import welcome from "./welcome/index.js";
import editReport from "./edit-report/edit-report.js";
import entities from "./entities/entities.js";
import exports from "./exports/exports.js";
import newReport from "./new-report/new-report.js";
import reportList from "./report-list/report-list.js";
import ruleProvider from "./rule-provider/rule-provider.js";
import proxies from "./proxies/proxies.js";
import { TRIGGER_METHODS } from "./rule-provider/constants.js";
import users from "./users/users.js";
import notices from "./notices/notices.js";
import viewReports from "./view-reports";

const deps = [
	complianceReport,
	dashboard,
	editReport,
	entities,
	newReport,
	notices,
	proxies,
	publicPages,
	reportList,
	ruleProvider,
	TRIGGER_METHODS,
	users,
	viewReports,
	welcome, 
	exports
];

export default angular.module("vesl.screens", deps).name;
